"use strict";

var conversions = require("webidl-conversions");

var utils = require("./utils.js");

module.exports = {
  convertInherit: function convertInherit(obj, ret) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$context = _ref.context,
        context = _ref$context === void 0 ? "The provided value" : _ref$context;

    {
      var key = "flatten";
      var value = obj === undefined || obj === null ? undefined : obj[key];

      if (value !== undefined) {
        value = conversions["boolean"](value, {
          context: context + " has member flatten that"
        });
        ret[key] = value;
      } else {
        ret[key] = false;
      }
    }
  },
  convert: function convert(obj) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$context = _ref2.context,
        context = _ref2$context === void 0 ? "The provided value" : _ref2$context;

    if (obj !== undefined && typeof obj !== "object" && typeof obj !== "function") {
      throw new TypeError("".concat(context, " is not an object."));
    }

    var ret = Object.create(null);
    module.exports.convertInherit(obj, ret, {
      context: context
    });
    return ret;
  }
};